import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5b62d572"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=5b62d572&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.5.0_webpack@5.105.4_postcss@8.5.17___lodash@4.18.1_pret_f03764d71fb520a4e32c35b9f5d4e0a5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports